import React from 'react';

import BetslipStakeInput from '../../BetslipStakeInput';
import Combinations from '../../Combinations';
import Error from '../../Error';
import TotalRow from '../TotalRow';
import useSystemPart from './useSystemPart';

import './systemPart.scss';

interface Props {
    betslipBetId: string;
}

const SystemPart: React.FC<Props> = ({ betslipBetId }) => {
    const props = useSystemPart({ betslipBetId });

    if (!props) return null;

    const {
        betslipOddsSize,
        stake,
        changeStakeHandler,
        errorMsgs,
        finalTotalStake,
        finalTotalWin,
        maxStakeForInput,
        onKeyDown,
    } = props;

    return (
        <div styleName="container">
            {errorMsgs.length > 0 && <Error messages={errorMsgs} />}
            <Combinations
                betslipBetId={betslipBetId}
                betslipOddsSize={betslipOddsSize}
            />
            <BetslipStakeInput
                maxStake={maxStakeForInput}
                changeValue={changeStakeHandler}
                value={stake}
                onKeyDown={onKeyDown}
            />
            <TotalRow
                betslipBetId={betslipBetId}
                totalStake={finalTotalStake}
                totalPotentialWin={finalTotalWin}
            />
        </div>
    );
};

export default React.memo(SystemPart);
